import React, { useState } from 'react';
import { Autocomplete, Box, Button, CircularProgress, IconButton, MenuItem, Stack, Typography } from '@mui/material';
import { Formik, FieldArray } from 'formik';
import Header from '../../components/Header';
import { authorizedPost, listAllInvoices, resetAllInvoices } from '../../store/actions';
import { CREATE_INVOICES_V1 } from '../../graphql';
import { CssTextField } from '../../components/TextField';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Add, Remove } from '@mui/icons-material';

function AddNewInvoice({ dispatch, smScreen, setOpenModal, hotelsList, packages }) {
    const [isLoading, setIsLoading] = useState(false);
    const optionsList = hotelsList.map((el, idx) => ({
        label: el.name,
        id: el._id,
    }))

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: smScreen ? 500 : "90%",
        maxHeight: "90vh",
        overflow: "auto",
        bgcolor: "#1F2A40",
        outline: "none",
        boxShadow: 24,
        p: 2,
    };

    const initialValues = {
        hotelId: "",
        packages: [{ package_id: "", custom_amount: 0 }],
        invDate: moment().format("YYYY-MM-DD"),
    };
    const handleFormSubmit = async (values) => {
        if(!values.hotelId) return toast.error("Please select a hotel")
        if(values.packages.some(p => !p.package_id)) return toast.error("Please select a package")
        setIsLoading(true);
        let data = {
            hotelId: values.hotelId,
            packages: values.packages.map((pkg) => ({ package_id: pkg.package_id, custom_amount: Number(pkg.custom_amount) || 0 })),
            invDate: moment(values.invDate, "YYYY-MM-DD").startOf("day").unix(),
            months: [{ month: moment(values.invDate, "YYYY-MM-DD").format("MMM-YYYY") }],
            invType: "normal"
        }
        console.log(data);
        await authorizedPost(CREATE_INVOICES_V1, data)
        dispatch(resetAllInvoices());
        dispatch(listAllInvoices());
        setIsLoading(false);
        setOpenModal(false);
    };

    return (
        <Box>
            <Box sx={modalStyle}>
                <Header title="CREATE NEW INVOICE" titleVariant="h4" />

                <Formik
                    onSubmit={handleFormSubmit}
                    initialValues={initialValues}
                >
                    {({ values, handleChange, handleSubmit, setFieldValue }) => (
                        <form onSubmit={handleSubmit}>

                            <Stack spacing={2}>
                                {/* <CssTextField
                                    fullWidth
                                    required
                                    select
                                    size='small'
                                    type="text"
                                    label="Hotel"
                                    name="hotelId"
                                    value={values.hotelId || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="" sx={{display: "none"}}></MenuItem>
                                    {hotelsList?.map((e) => (
                                        <MenuItem value={e._id} key={e._id}>
                                            {e.name}
                                        </MenuItem>
                                    ))}
                                </CssTextField> */}
                                <Autocomplete
                                    // disablePortal
                                    id="combo-box-demo"
                                    fullWidth
                                    size='small'
                                    options={optionsList}
                                    onChange={(e, value) => setFieldValue("hotelId", value?.id ?? "")}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    renderInput={(params) => <CssTextField required {...params} label="Hotel" />}
                                />
                                
                                <FieldArray name="packages">
                                    {({ push, remove }) => (
                                        <Stack spacing={2}>
                                            <Typography variant="subtitle1">Packages</Typography>
                                            {values.packages.map((pkg, index) => (
                                                <Stack direction="row" spacing={1} key={index} alignItems="center">
                                                    <CssTextField
                                                        fullWidth
                                                        select
                                                        size='small'
                                                        type="text"
                                                        label="Package"
                                                        name={`packages[${index}].package_id`}
                                                        value={pkg.package_id || ""}
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem value="" sx={{display: "none"}}></MenuItem>
                                                        {packages?.map((e) => (
                                                            <MenuItem value={e._id} key={e._id}>
                                                                {e.name}
                                                            </MenuItem>
                                                        ))}
                                                    </CssTextField>
                                                    <CssTextField
                                                        fullWidth
                                                        size='small'
                                                        type="float"
                                                        label="Custom amount"
                                                        name={`packages[${index}].custom_amount`}
                                                        value={pkg.custom_amount === 0 ? "" : pkg.custom_amount}
                                                        onChange={handleChange}
                                                        InputProps={{ inputProps: { min: 0 } }}
                                                    />
                                                    <IconButton color="error" onClick={() => remove(index)} disabled={values.packages.length <= 1}>
                                                        <Remove />
                                                    </IconButton>
                                                </Stack>
                                            ))}
                                            <Button
                                                variant="outlined"
                                                startIcon={<Add />}
                                                onClick={() => push({ package_id: "", custom_amount: 0 })}
                                            >
                                                Add Package
                                            </Button>
                                        </Stack>
                                    )}
                                </FieldArray>

                                <CssTextField
                                    fullWidth
                                    size='small'
                                    type="date"
                                    label="Invoice Date"
                                    name="invDate"
                                    value={values?.invDate}
                                    onChange={handleChange}
                                />
                                <Button
                                    fullWidth
                                    size="large"
                                    type="submit"
                                    color="secondary"
                                    variant="contained"
                                    sx={{ fontSize: "15px" }}
                                >
                                    {isLoading ? <CircularProgress color="inherit" size={24} /> : <b>Submit</b>}
                                </Button>
                            </Stack>
                        </form>
                    )}
                </Formik>
            </Box>
        </Box>
    )
}

export default AddNewInvoice